module.exports = __webpack_public_path__ + "img/leval-10.9fe8df54.png";